import { tableFunc } from '../../utils/tableFunc.js';
import { Currency } from './CurrencyProps.js';
export const callbackCurrencySelect = (props) => tableFunc([
    [
        (_) => _.value !== Currency.RUB && _.oppositeValue !== Currency.RUB,
        () => props.handleConvert(props.value, Currency.RUB),
    ],
    [
        (_) => _.value === Currency.RUB && _.oppositeValue === Currency.RUB,
        () => props.handleConvert(props.value, Currency.USD),
    ],
    [
        (_) => _.value === Currency.RUB && _.oppositeValue === Currency.RUB,
        () => props.handleConvert(props.value, Currency.CNY),
    ],
    [() => true, () => props.handleConvert(props.value)],
])(props)?.();
//# sourceMappingURL=callbackCurrencySelect.js.map